import React from 'react';
import { Link } from 'react-router-dom';
import { footerLinks } from '../../mocks/footerlinks/index.ts';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const handleSocial = (url: string) => {
  const href = url.startsWith('http') ? url : `https://${url}`;
  window.open(href, '_blank', 'noopener,noreferrer');
};

export const Footer = () => (
  <footer style={s.wrapper}>

    {/* ── Country links — subtle row, backs unique per-country landing pages ── */}
    <div style={s.countrySection}>
      <div style={s.countryInner}>
        <span style={s.countryLabel}>Colivings by country</span>
        {footerLinks.map((link) => (
          <Link key={link.id} to={link.url} style={s.countryLink}>{link.label}</Link>
        ))}
      </div>
    </div>

    {/* ── Main bar — landing footer style ── */}
    <div style={s.bar}>
      <div style={s.barInner}>
        <span style={s.logo}>The Colivings</span>

        <div style={s.links}>
          <Link to="/"       style={s.link}>For Nomads</Link>
          <Link to="/landing" style={s.link}>For Colivings</Link>
          <Link to="/about"  style={s.link}>About</Link>
        </div>

        <div style={s.social}>
          <button
            style={s.socialBtn}
            onClick={() => handleSocial('https://www.instagram.com/colivingmadrid/')}
            aria-label="Instagram"
          >
            <InstagramIcon style={{ fontSize: '1rem' }} />
          </button>
          <button
            style={s.socialBtn}
            onClick={() => handleSocial('https://www.linkedin.com/in/luyezhan/')}
            aria-label="LinkedIn"
          >
            <LinkedInIcon style={{ fontSize: '1rem' }} />
          </button>
        </div>
      </div>
    </div>

    {/* ── Bottom strip ── */}
    <div style={s.bottom}>
      <div style={s.bottomInner}>
        <span style={s.copy}>© 2026 The Lazy Company &amp; Friends S.L. · Community first.</span>
        <div style={s.legal}>
          <Link to="/privacy" style={s.legalLink}>Privacy</Link>
          <Link to="/terms"   style={s.legalLink}>Terms</Link>
          <Link to="/cookies" style={s.legalLink}>Cookies</Link>
        </div>
      </div>
    </div>

  </footer>
);

const s: Record<string, React.CSSProperties> = {
  wrapper: { background: '#140C06', fontFamily: "'DM Sans', sans-serif" },

  /* Country links */
  countrySection: { borderBottom: '1px solid rgba(255,255,255,0.06)', padding: '18px 24px' },
  countryInner: { maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '10px 18px' },
  countryLabel: { fontSize: 10, fontWeight: 700, letterSpacing: '0.2em', textTransform: 'uppercase' as const, color: 'rgba(255,255,255,0.25)' },
  countryLink: { fontSize: 13, color: 'rgba(255,255,255,0.4)', textDecoration: 'none' },

  /* Main bar */
  bar: { padding: '28px 24px' },
  barInner: { maxWidth: 1100, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 },
  logo: { fontFamily: "'Cormorant Garamond', serif", fontSize: 22, fontWeight: 700, color: 'rgba(255,255,255,0.85)', letterSpacing: '-0.01em' },
  links: { display: 'flex', gap: 28, flexWrap: 'wrap' },
  link: { fontSize: 14, color: 'rgba(255,255,255,0.45)', textDecoration: 'none' },
  social: { display: 'flex', gap: 8 },
  socialBtn: { background: 'rgba(255,255,255,0.07)', border: 'none', borderRadius: 8, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: 'rgba(255,255,255,0.45)' },

  /* Bottom strip */
  bottom: { borderTop: '1px solid rgba(255,255,255,0.06)', padding: '16px 24px' },
  bottomInner: { maxWidth: 1100, margin: '0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  copy: { fontSize: 12, color: 'rgba(255,255,255,0.2)' },
  legal: { display: 'flex', gap: 20 },
  legalLink: { fontSize: 12, color: 'rgba(255,255,255,0.2)', textDecoration: 'none' },
};
